import { Scope, UIFeature, useMainStore } from "#imports"

/** Every permission scope of the API, grouped by the resource it applies to, in display order. */
export const scopesByResource = {
  company: [Scope.enum["read:company"], Scope.enum["write:company"]],
  contract: [Scope.enum["read:contract"], Scope.enum["write:contract"]],
  invoice: [
    Scope.enum["read:invoice"],
    Scope.enum["write:invoice"],
    Scope.enum["write:invoice_accounted"],
  ],
  finance: [Scope.enum["read:finance"]],
  document: [
    Scope.enum["read:document"],
    Scope.enum["write:document"],
    Scope.enum["upload:document"],
  ],
  market: [Scope.enum["read:market"], Scope.enum["write:market"]],
  partner: [Scope.enum["read:partner"]],
  note: [Scope.enum["read:note"], Scope.enum["write:note"]],
  event: [Scope.enum["read:event"], Scope.enum["write:event"]],
  supervision: [Scope.enum["read:supervision"], Scope.enum["write:supervision"]],
  timeseries: [
    Scope.enum["read:timeseries"],
    Scope.enum["write:timeseries"],
    Scope.enum["order:timeseries"],
  ],
  datastudio: [Scope.enum["read:datastudio"]],
  data: [
    Scope.enum["write:geo"],
    Scope.enum["write:goldensource"],
    Scope.enum["write:datahealth"],
    Scope.enum["write:metric"],
  ],
} as const satisfies Record<string, readonly Scope[]>
export type ScopeResource = keyof typeof scopesByResource

export function hasScope(...scopes: Scope[]): boolean {
  const permissions = useMainStore().user?.permissions || []

  return scopes.every((scope) => permissions.includes(scope))
}

export function hasUIFeature(...features: UIFeature[]): boolean {
  const uiFeatures = useMainStore().user?.ui_features || []

  return features.every((feature) => uiFeatures.includes(feature))
}

export function filterDropdownItemOnScope<DropdownItemT>(
  itemsScopes: (DropdownItemT & { scope?: Scope })[][],
): DropdownItemT[][] {
  return R.map(itemsScopes, (items) =>
    items
      .filter((item) => item.scope === undefined || hasScope(item.scope))
      .map((item) => R.pickBy(item, (_, key) => key !== "scope") as DropdownItemT),
  )
}
